<template>
	<v-app class="auth-page">
		<Header />
		<div class="login-block">
			<div class="container" lg>
				<div class="row">
					<div class="col-lg-12">
						<h1 v-html="$t('sign_as_'+loginType)"></h1>

						<template v-if="loginType === 'abiturient' && !authMethod">
							<div>
								<div class="container">
									<div class="row justify-center">
										<div class="col-lg-12 mb-4">
											<div class="section_title text_center mt-3">
												<div class="section_main_title">
													<h2>{{ $t('Выберите способ авторизации') }}</h2>
												</div>
											</div>
										</div>
										<div class="col-lg-5 col-md-6 col-sm-12 my-0 mx-auto">
											<div class="service_style_one text_center pt-40 pb-40 pl-3 pr-3 mb-4" @click="selectAuthMethod('ecp')">
												<div class="service_style_one_icon mb-30">
													<i><v-icon size="48" color="primary">mdi-certificate</v-icon></i>
												</div>
												<div class="service_style_one_title mb-30">
													<h4>{{ $t('Вход через ЭЦП') }}</h4>
												</div>
												<div class="service_style_one_text">
													<p>{{ $t('Авторизация с помощью электронно-цифровой подписи физического лица') }}</p>
												</div>
												<div class="service_style_one_button pt-3">
													<a href="#" @click.prevent="selectAuthMethod('ecp')">{{ $t('Продолжить') }} →</a>
												</div>
											</div>
										</div>
										<div class="col-lg-5 col-md-6 col-sm-12 my-0 mx-auto">
											<div class="service_style_one text_center pt-40 pb-40 pl-3 pr-3 mb-4" @click="selectAuthMethod('password')">
												<div class="service_style_one_icon mb-30">
													<i><v-icon size="48" color="primary">mdi-lock-outline</v-icon></i>
												</div>
												<div class="service_style_one_title mb-30">
													<h4>{{ $t('Вход по паролю') }}</h4>
												</div>
												<div class="service_style_one_text">
													<p>{{ $t('Авторизация с помощью логина и пароля личного кабинета') }}</p>
												</div>
												<div class="service_style_one_button pt-3">
													<a href="#" @click.prevent="selectAuthMethod('password')">{{ $t('Продолжить') }} →</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>

						<div v-else class="row">
							<div class="col-lg-8">
								<v-btn
									v-if="loginType === 'abiturient'"
									text
									class="auth-page__back"
									@click="backToAuthMethodSelection"
								>
									<v-icon left>mdi-arrow-left</v-icon>
									{{ $t('Назад к выбору способа авторизации') }}
								</v-btn>
								<div class="text-center" style="margin-top: 20px;">
									<v-form
										v-if="loginType !== 'abiturient' || authMethod === 'ecp'"
										class="form light-blue lighten-4 px-6 pb-8 pt-9"
										ref="ecpForm"
										@submit.prevent="handleEcpSubmit"
									>
										<v-file-input
											filled
											class="mb-3"
											:label="$t('Выберите ЭЦП '+(loginType == 'abiturient' ? 'физического' : 'юридического')+' лица')"
											accept=".p12"
											:rules="[v => !!v || $t('Выберите ЭЦП')]"
											@change="toBase64"
										></v-file-input>
										<v-text-field
											filled
											:label="$t('Пароль от ЭЦП')"
											type="password"
											prepend-icon="mdi-key"
											v-model="ecpPassword"
											:rules="[v => !!v || $t('Введите пароль')]"
										></v-text-field>

										<v-flex class="d-flex justify-center">
											<v-btn
												height="40px"
												dark
												color="light-blue darken-2"
												class="login"
												type="submit"
												:loading="loading"
											>
												{{ $t('Войти в систему') }}
											</v-btn>
										</v-flex>
									</v-form>

									<v-form
										v-else-if="loginType === 'abiturient' && authMethod === 'password'"
										class="form light-blue lighten-4 px-6 pb-8 pt-9"
										ref="passwordForm"
										@submit.prevent="handlePasswordSubmit"
									>
										<v-text-field
											filled
											v-model="accountLogin"
											:label="$t('Логин')"
											type="text"
											prepend-icon="mdi-account-outline"
											:rules="[v => !!v || $t('Обязательное поле')]"
										></v-text-field>
										<v-text-field
											filled
											v-model="accountPassword"
											:label="$t('Пароль')"
											type="password"
											prepend-icon="mdi-lock-outline"
											:rules="[v => !!v || $t('Введите пароль')]"
										></v-text-field>

										<v-flex class="d-flex justify-center">
											<v-btn
												height="40px"
												dark
												color="light-blue darken-2"
												class="login"
												type="submit"
												:loading="loading"
											>
												{{ $t('Войти в систему') }}
											</v-btn>
										</v-flex>
									</v-form>
								</div>
							</div>
							<div class="col-lg-4">
								<div class="single_faq mb-4">
									<div class="single_faq_content">
										<div class="single_faq_text pt-4" v-html="$t(loginType+'_login_text')"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="faq_area bg_color2 pt-90 pb-70">
			<div class="container">
				<div class="row">
					<div class="col-lg-12 mb-5">
						<div class="section_title text_center mt-3">
							<div class="section_sub_title uppercase mb-3">
								<h6>{{ $t('Управление колледжом') }}</h6>
							</div>
							<div class="section_main_title">
								<h1 v-html="$t('sign_for')"></h1>
							</div>
							<div class="em_bar">
								<div class="em_bar_bg"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="row justify-content-center">
					<div class="col-lg-6 col-md-6 mx-auto my-0" v-if="loginType != 'abiturient'">
						<div class="single_faq mb-4">
							<div class="single_faq_content">
								<div class="single_faq_title pb-2">
									<h5>{{ $t('Вход в кабинет абитуриента') }}</h5>
								</div>
								<div class="single_faq_text">
									<p>{{ $t('ИС позволяет подавать документы для поступления в колледж на бесплатное обучение по государственному заказу и отслеживать их статус. Итоговые результаты отображаются в разделе ранжирование. Есть возможность задать интересующие вопросы в приемную комиссию.') }}</p>
								</div>
								<div class="pt-2 pb-5">
									<div class="btn btn-primary" @click.stop="changeLoginType('abiturient')">
										{{ $t('Вход в кабинет') }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-6 col-md-6 mx-auto my-0" v-if="loginType != 'college'">
						<div class="single_faq mb-4">
							<div class="single_faq_content">
								<div class="single_faq_title pb-2">
									<h5>{{ $t('Приемная комиссия колледжа') }}</h5>
								</div>
								<div class="single_faq_text">
									<p>{{ $t('Приемная комиссия колледжа может отслеживать поступающие заявки от абитуриентов. Система позволяет управлять процессами приема и отказа в колледж. Требуется ЭЦП юридического учреждения.') }}</p>
								</div>
								<div class="pt-2 pb-5">
									<div class="btn btn-primary" @click.stop="changeLoginType('college')">
										{{ $t('Вход в кабинет') }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- ТиПО
					<div class="col-lg-6 col-md-6" v-if="loginType != 'department'">
						<div class="single_faq mb-4">
							<div class="single_faq_content">
								<div class="single_faq_title pb-2">
									<h5>{{ $t('Управление ТиПО') }}</h5>
								</div>
								<div class="single_faq_text">
									<p>{{ $t('Вход в кабинет для Управления Образования (ТиПО) позволяет проводить мониторинг по приему абитуриентов подведомственных организаций (колледжей). Отображаются актуальные статистические данные. Имеется виртуальный блог.') }}</p>
								</div>
								<div class="pt-2 pb-5">
									<div class="btn btn-primary" @click.stop="changeLoginType('department')">
										{{ $t('Вход в кабинет') }}
									</div>
								</div>
							</div>
						</div>
					</div>
					-->
				</div>
			</div>
		</div>
		<Footer />
	</v-app>
</template>

<script>
	import Header from '@/components/abiturient/Header.vue'
	import Footer from '@/components/abiturient/Footer.vue'
	import config from '@/config'
	import { isValidReturnUrl, getRoleHomeRouteName } from '@/router/utils'
	import { mapAbiturientUser, mapCollegeUser } from '@/utils/auth'

	export default {
		components: {
			Header,
			Footer
		},
		watch: {
			'$route.params.user': {
				immediate: true,
				handler() {
					this.syncLoginTypeFromRoute();
				},
			},
		},
		computed: {
			selectedLanguage() {
				return this.$store.state.language;
			}
		},
		data: () => ({
			authMethod: null,
			ecpFileData: '',
			ecpPassword: '',
			accountLogin: '',
			accountPassword: '',
			loginType: 'abiturient',
			loading: false,
		}),
		methods: {
			syncLoginTypeFromRoute() {
				const user = this.$route.params.user;
				if (user && ['abiturient', 'college'/*, 'department'*/].includes(user)) {
					this.loginType = user;
					this.authMethod = user === 'abiturient' ? null : 'ecp';
					this.resetForms();
				}
			},
			getAbiturientAuthBaseUrl() {
				return `${config.API_URL}api/abiturient`;
			},
			getCollegeAuthBaseUrl() {
				return `${config.API_URL}api/college`;
			},
			selectAuthMethod(method) {
				this.authMethod = method;
			},
			backToAuthMethodSelection() {
				this.authMethod = null;
				this.resetForms();
			},
			resetForms() {
				this.ecpFileData = '';
				this.ecpPassword = '';
				this.accountLogin = '';
				this.accountPassword = '';
			},
			changeLoginType(user) {
				this.$router.push({ path: '/login/' + user });
				window.scrollTo(0, 0);
			},
			async handleEcpSubmit() {
				if (!this.$refs.ecpForm.validate()) {
					return;
				}
				this.loading = true;
				try {
					if (this.loginType === 'abiturient') {
						const formData = new FormData();
						formData.append('ecp', this.ecpFileData);
						formData.append('password', this.ecpPassword);

						const response = await this.$http.post('/login-ecp', formData, {
							baseURL: this.getAbiturientAuthBaseUrl(),
						});

						if (!response.data.status) {
							this.$store.dispatch('alertAdd', {
								text: response.data.message || this.$t('Ошибка авторизации'),
								type: 'error',
							});
							this.loading = false;
							return;
						}

						await this.processLoginSuccess(response, {
							authMethod: 'ecp',
							abiturientInfo: mapAbiturientUser(response.data.data.user),
						});
						return;
					}

					if (this.loginType === 'college') {
						const formData = new FormData();
						formData.append('ecp', this.ecpFileData);
						formData.append('password', this.ecpPassword);

						const response = await this.$http.post('/login', formData, {
							baseURL: this.getCollegeAuthBaseUrl(),
						});

						if (!response.data.status) {
							this.$store.dispatch('alertAdd', {
								text: response.data.message || this.$t('Ошибка авторизации'),
								type: 'error',
							});
							this.loading = false;
							return;
						}

						await this.processLoginSuccess(response, {
							authMethod: 'ecp',
							collegeInfo: mapCollegeUser(response.data.data),
						});
						return;
					}

					// ТиПО
					// const response = await this.$http.post('/api/login-ecp', {
					// 	ecp: this.ecpFileData,
					// 	password: this.ecpPassword,
					// });
					// await this.processLoginSuccess(response, { authMethod: 'ecp' });
				} catch (e) {
					this.loading = false;
				}
			},
			async handlePasswordSubmit() {
				if (!this.$refs.passwordForm.validate()) {
					return;
				}
				this.loading = true;
				try {
					const formData = new FormData();
					formData.append('login', this.accountLogin);
					formData.append('password', this.accountPassword);

					const response = await this.$http.post('/login', formData, {
						baseURL: this.getAbiturientAuthBaseUrl(),
					});

					if (!response.data.status) {
						this.$store.dispatch('alertAdd', {
							text: response.data.message || this.$t('Ошибка авторизации'),
							type: 'error',
						});
						this.loading = false;
						return;
					}

					await this.processLoginSuccess(response, {
						authMethod: 'password',
						abiturientInfo: this.mapPasswordUser(response.data.data.user),
					});
				} catch (e) {
					this.loading = false;
				}
			},
			mapPasswordUser(user) {
				return mapAbiturientUser(user);
			},
			async processLoginSuccess(response, options = {}) {
				this.loading = false;
				this.$store.commit('setCurrentRole', this.loginType);
				this.$store.commit('setAuthMethod', options.authMethod || 'ecp');
				if (this.loginType === 'college') {
					const loginData = response.data.data || {};
					const collegeInfo = options.collegeInfo && Object.keys(options.collegeInfo).length
						? options.collegeInfo
						: mapCollegeUser(loginData.user || loginData);
					this.$store.commit('setCollegeInfo', collegeInfo);
				} else if (this.loginType === 'abiturient') {
					const loginData = response.data.data || {};
					this.$store.commit('setNewAbiturientUser', Boolean(loginData.newuser));
					this.$store.commit(
						'setAbiturientInfo',
						options.abiturientInfo || mapAbiturientUser(loginData.user || loginData)
					);
				// } else if (this.loginType === 'department') {
				// 	this.$store.commit('setTipoInfo', response.data.data);
				}
				await this.$store.dispatch('login', response);
				await this.$store.dispatch('changeBaseUrl');

				const returnUrl = this.$route.query.url;
				const homeRoute = getRoleHomeRouteName(this.loginType);

				if (isValidReturnUrl(returnUrl, this.loginType)) {
					await this.$router.replace({ path: returnUrl });
				} else {
					await this.$router.replace(
						homeRoute ? { name: homeRoute } : { name: this.loginType }
					);
				}
			},
			toBase64(file) {
				if (file) {
					const reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = () => {
						let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
						if ((encoded.length % 4) > 0) {
							encoded += '='.repeat(4 - (encoded.length % 4));
						}
						this.ecpFileData = encoded;
					};
				}
			},
		},
	};
</script>
<style type="text/css" scoped src="@/assets/css/abiturient.css"></style>
<style scoped src="@/assets/css/abiturient/Auth.css"></style>
<style scoped>
	@media (min-width: 1904px) {
		.container {
			max-width: 1140px !important;
		}
	}
	.login-block {
		padding-top: 70px;
		padding-bottom: 90px;
	}
</style>
<style type="text/css">
	.v-input__slot {
		background-color: #fff !important;
	}
</style>
